import React, { useState, useContext } from 'react';
import { Visibility, VisibilityOff, Lock } from '@mui/icons-material';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  Typography,
} from '@mui/material';
import { ContextUser } from '../../../providers/ContextUser';

const Login = ({ handleAction }) => {
  const [requesting, setRequesting] = useState(false);
  const [fields, setFields] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);

  const { handleLogin } = useContext(ContextUser);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setRequesting(true);
    handleLogin(fields).finally(() => setRequesting(false));
  };

  return (
    <>
             <Box
         sx={{
           maxWidth: 400,
           width: '100%',
           background: 'rgba(255, 255, 255, 0.95)',
           backdropFilter: 'blur(20px)',
           padding: { xs: 2, md: 4 },
           borderRadius: 2,
           marginBottom: 2,
           boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
           border: '1px solid rgba(255, 255, 255, 0.2)',
           position: 'relative',
           zIndex: 1,
         }}
       >
         {/* Título do formulário */}
         <Box sx={{ textAlign: 'center', mb: 4 }}>
           <Typography
             variant="h4"
             sx={{
               fontWeight: 700,
               color: '#1a1a2e',
               mb: 1,
             }}
           >
             Login
           </Typography>
           
           <Typography
             variant="body1"
             sx={{
               color: '#666',
               fontSize: '16px',
             }}
           >
             Acesse sua conta SOLIS para continuar
           </Typography>
         </Box>

        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin='normal' variant='outlined'>
            <InputLabel htmlFor='email' shrink={!!fields.email}>Seu email</InputLabel>
            <OutlinedInput
              id='email'
              type='email'
              name='email'
              value={fields.email}
              onChange={handleChange}
              label='Seu email'
              notched={!!fields.email}
            />
          </FormControl>
          
          <FormControl fullWidth margin='normal' variant='outlined'>
            <InputLabel htmlFor='password' shrink={!!fields.password}>Senha</InputLabel>
            <OutlinedInput
              id='password'
              type={showPassword ? 'text' : 'password'}
              name='password'
              value={fields.password}
              onChange={handleChange}
              label='Senha'
              notched={!!fields.password}
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowPassword(!showPassword)}
                    edge='end'
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          
          {/* Link "Esqueceu sua senha?" alinhado à direita */}
          <Box sx={{ textAlign: 'right', mt: 1, mb: 2 }}>
            <Button
              variant='text'
              color='primary'
              onClick={() => handleAction('forgot')}
              sx={{
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500,
                p: 0,
                minWidth: 'auto',
              }}
            >
              Esqueceu sua senha?
            </Button>
          </Box>
          
                     <Button
             type='submit'
             variant='contained'
             color='primary'
             fullWidth
             disabled={requesting}
             sx={{ mt: 2 }}
           >
             {requesting ? (
               <CircularProgress size={24} color='inherit' />
             ) : (
               'Entrar'
             )}
           </Button>
         </form>
      </Box>
    </>
  );
};

export default Login;
